import React, {useEffect, useState} from 'react';
import {getImages} from "../../services/MediaRepository";
import {SimpleGrid} from "../../components/SimpleGrid";
import {ImageGridElement} from "./ImageGridElement";
import {CMSHeader} from "./CMSHeader";


export function ImageAdmin() {

    const [page, setPage] = useState(0);
    const [maxPage, setMaxPage] = useState(1);
    const [images, setImages] = useState([]);

    useEffect(() => {
        getImages(page).then(result => {
            setImages(result.content)
            setMaxPage(result.totalPages-1)
        }).catch(e => console.log(e.message));
    }, [page]);


    return (
        <div className={"bg-dark"}>
           <CMSHeader page={page} maxPage={maxPage} setPage={setPage} context={"Bilder"}/>
            <div className={"container pb-5 mb-5"}>
                <SimpleGrid rowSize={5} fill={true}>
                    {
                        images.map(image => (
                          <ImageGridElement image={image}/>
                        ))
                    }
                </SimpleGrid>
            </div>
        </div>
    );

}